export { default as stringToAvatar } from './stringToAvatar';
export { default as toBase64 } from './toBase64';
export { default as dataMapper } from './dataMapper';
export { default as Logger } from './logger';
export { default as getLastTimeServiceRan } from './getLastTimeServiceRan';
export { default as setLastTimeServiceRan } from './setLastTimeServiceRan';
export { default as handleError } from './handleError';
